import { accountCodingSchema } from "./account-coding";

export const addressAccountSchema = {
  $id: "/schemas/addressAccountSchema",
  type: "object",
  properties: {
    name: { type: "string" },
    partnerId: { type: "string" },
    notes: { type: "string" },
    notesLoading: { type: "string" },
    notesPackaging: { type: "string" },
    safety: {
      type: "object",
      properties: {
        instructions: { type: "string" },
        pbm: {
          type: "array",
          items: { type: "string" }
        }
      },
      required: ["instructions", "pbm"]
    },
    type: { type: "string" },
    certificates: {
      type: "array",
      items: { type: "string" }
    },
    hours: { type: "string" },
    contacts: {
      type: "array",
      items: {
        type: "object",
        properties: {
          contactType: { type: "string" },
          type: { type: "string" },
          title: { type: "string" },
          firstName: { type: "string" },
          lastName: { type: "string" },
          mail: { type: "string" },
          phone: { type: "string" },
          deleted: { type: "boolean" }
        },
        required: []
      }
    }
  },
  required: []
};

export const addressOverridesSchema = {
  $id: "/schemas/addressOverridesSchema",
  type: "object",
  properties: {
    overrides: {
      type: "object",
      properties: {
        street: { type: "string" },
        countryCode: { type: "string" },
        number: { type: "string" },
        city: { type: "string" },
        zip: { type: "string" }
      }
    }
  },
  required: []
};

export const addressAnnotationSchema = {
  $id: "/schemas/addressAnnotationSchema",
  type: "object",
  properties: {
    id: { type: "string" }, // identifies who is annotating
    coding: { $ref: "#/definitions/accountCodingSchema" }
  },


  // used to extend the schema:
  allOf: [
    { $ref: "#/definitions/addressAccountSchema" },
    { $ref: "#/definitions/addressOverridesSchema" }
  ],
  required: ["id"],
  definitions: {
    accountCodingSchema,
    addressAccountSchema,
    addressOverridesSchema
  }
};
